// import {
//   recipeListParser, recipeParser, ingredientListParser, unitListParser,
// } from './DataParser';

const API_URL = 'https://vidnet-86f9.restdb.io/rest/';
const API_KEY = '5e9e501d436377171a0c268c';

class VidNetAPI {
  constructor() {
    this.apiUrl = API_URL;
    this.apikey = API_KEY;
  }

  // Get all RecipeIngredients grouped by RecipeId
  async getVideoSequences() {
    const url = `${this.apiUrl}video-sequence-data`;
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'x-apikey': this.apikey,
      },
    });
    if (response.status >= 400) {
      throw Error(response.statusText);
    }
    const json = await response.json();

    return json;
  }

  // post a sequence of clips to the db
  async postVideoSequence(object) {
    const url = `${this.apiUrl}video-sequence-data`;

    const response = await fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'x-apikey': this.apikey,
      },
      body: JSON.stringify(object),
    });

    if (response.status >= 400) {
      throw Error(response.statusText);
    }

    console.log(response);
  }
}

export default VidNetAPI;
